/**
 * @file Markdown 渲染组件
 * @description 用于显示 Markdown 格式的内容，支持协议弹窗和 WebView
 */
<template>
  <div class="markdown-viewer" :class="{ 'markdown-viewer--bordered': bordered }">
    <div class="markdown-body" v-html="renderedContent"></div>
  </div>
</template>

<script>
import { marked } from 'marked';

export default {
  name: 'MarkdownViewer',
  props: {
    // Markdown 内容
    content: {
      type: String,
      default: ''
    },
    // 是否显示边框
    bordered: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    renderedContent() {
      if (!this.content) return '';
      
      // 使用 marked 解析 Markdown
      return marked.parse(this.content, {
        breaks: true,        // 支持 GitHub 风格的换行
        gfm: true            // 启用 GitHub 风格的 Markdown
      });
    }
  }
}
</script>

<style lang="less">
.markdown-viewer {
  &--bordered {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 16px 20px;
    background: #fff;
  }
  
  .markdown-body {
    font-size: 14px;
    line-height: 1.8;
    color: #303133;
    word-wrap: break-word;
    
    // 标题样式
    h1, h2, h3, h4, h5, h6 {
      margin-top: 24px;
      margin-bottom: 16px;
      font-weight: 600;
      line-height: 1.25;
      color: #1f2329;
    }
    
    h1 {
      font-size: 24px;
      padding-bottom: 12px;
      border-bottom: 1px solid #e4e7ed;
    }
    
    h2 {
      font-size: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e4e7ed;
    }
    
    h3 {
      font-size: 18px;
    }
    
    h4 {
      font-size: 16px;
    }
    
    h5, h6 {
      font-size: 14px;
    }
    
    // 段落
    p {
      margin-top: 0;
      margin-bottom: 16px;
    }
    
    // 链接
    a {
      color: #2B77FF;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
    
    // 列表
    ul, ol {
      padding-left: 2em;
      margin-top: 0;
      margin-bottom: 16px;
    }
    
    li {
      margin-bottom: 4px;
      
      & + li {
        margin-top: 4px;
      }
    }
    
    // 引用
    blockquote {
      margin: 0 0 16px;
      padding: 12px 16px;
      color: #606266;
      background: #f8fafc;
      border-left: 4px solid #2B77FF;
      border-radius: 0 4px 4px 0;
      
      p:last-child {
        margin-bottom: 0;
      }
    }
    
    // 代码
    code {
      padding: 2px 6px;
      font-size: 13px;
      font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
      background: #f5f7fa;
      border-radius: 4px;
      color: #c7254e;
    }
    
    pre {
      margin: 0 0 16px;
      padding: 16px;
      overflow: auto;
      font-size: 13px;
      line-height: 1.6;
      background: #f5f7fa;
      border-radius: 8px;
      
      code {
        padding: 0;
        background: transparent;
        color: #303133;
      }
    }
    
    // 表格
    table {
      width: 100%;
      margin-bottom: 16px;
      border-collapse: collapse;
      border-spacing: 0;
      
      th, td {
        padding: 10px 12px;
        border: 1px solid #e4e7ed;
        text-align: left;
      }
      
      th {
        font-weight: 600;
        background: #f5f7fa;
      }
      
      tr:nth-child(even) {
        background: #fafbfc;
      }
    }
    
    // 分割线
    hr {
      height: 1px;
      margin: 24px 0;
      background: #e4e7ed;
      border: none;
    }
    
    // 图片
    img {
      max-width: 100%;
      height: auto;
      border-radius: 4px;
    }
    
    // 强调
    strong {
      font-weight: 600;
    }
    
    em {
      font-style: italic;
    }
    
    // 删除线
    del {
      color: #909399;
    }
    
    // 任务列表
    input[type="checkbox"] {
      margin-right: 8px;
    }
  }
}
</style>
